import eventBus from "@/eventBus";

// Mixin az eventBus-figyelők BIZTONSÁGOS regisztrálásához.
//
// MIÉRT KELL: a projekt komponenseinek nagy része a `created()`-ben
// `eventBus.$on(...)`-nal iratkozik fel, de a megsemmisüléskor SOHA nem
// iratkozik le. Amíg egy komponens a session teljes hosszában él, ez nem
// okoz gondot - de ha valaha megsemmisül és újra létrejön (útvonalváltás,
// egy `v-if` átbillenése, dinamikus komponens-csere), a régi példány
// figyelői BENT MARADNAK az eventBus-ban, és minden eseménynél lefutnak egy
// már halott komponensen. Két azonos figyelő pl. egy kattintásra KÉT
// eseményt menthetne. Hogy ez valós kockázat, azt a `ReportScreen.vue`
// `loadComponents()`-e is mutatja, ahol emiatt kézzel kell `$off`-olni.
//
// HASZNÁLAT: `eventBus.$on(X, fn)` helyett `this.$busOn(X, fn)`.
// A `beforeDestroy` ezután automatikusan leiratkoztat.
//
// FONTOS: a leiratkozás MINDIG a konkrét kezelő-referenciával történik
// (`$off(event, handler)`), soha nem csak az eseménynévvel - a paraméter
// nélküli `$off(event)` ugyanis az ÖSSZES figyelőt eltávolítaná arra az
// eseményre, beleértve a többi, még élő komponensét is.
export default {
    methods: {
        $busOn(event, handler) {
            if (!this._busHandlers) this._busHandlers = [];
            this._busHandlers.push([event, handler]);
            eventBus.$on(event, handler);
            return handler;
        }
    },
    beforeDestroy() {
        if (!this._busHandlers) return;
        this._busHandlers.forEach(([event, handler]) => eventBus.$off(event, handler));
        this._busHandlers = null;
    }
};
